export default __webpack_public_path__ + "static/media/photo-upload-placeholder.53c25c53.svg";